<template>
    <div>
        <!-- ============= 검색 조건============= -->
        <ExtSiteSearch v-bind:queryParams="queryParams"
                         v-bind:fullDate="fullDate" />

        <div class="two-table">
          <ExtSiteList v-bind:queryParams="queryParams"
                         v-bind:fullDate="fullDate" />

          <ExtSiteDetailList v-bind:queryParams="queryParams"
                     v-bind:fullDate="fullDate" />
        </div>
    </div>
</template>
<script>
import ExtSiteSearch from './component/ExtSiteSearch.vue';
import ExtSiteList from './component/ExtSiteList.vue';
import ExtSiteDetailList from './component/ExtSiteDetailList.vue';

export default {
    name: "extSiteManagementList",
    data() {
        return {
            fullDate: [],
            queryParams: {
                keyword: '',    // 검색 키워드
                status: [],     // 사용유무
                sites: [],      // 사이트
                categorys: [],  // 관심카테고리
                hashtags: [],   // 해시태그 유무
            },
        }
    },
    components: {
        ExtSiteSearch,
        ExtSiteList,
        ExtSiteDetailList,
    },
    methods: {
        getFormatDate(date) {
            if (!date) return;
            return moment(date).format("YYYY-MM-DD");
        },
    },
}
</script>
<style scoped>
  .mx-datepicker{
    width : 100% !important;
  }

  table tr th, td {
    text-align: center;
  }

  @media(min-width: 1400px) {
    .two-table{
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/contents/extSite/ExtSiteManagementList.vue